import { size } from 'driverama-core/styles/spacing'

export function RequiredMark() {
  return <span css={{ color: '#f44336', marginLeft: size(0.5) }}>*</span>
}
